import { Grid } from 'react-loader-spinner'
import { useColors } from 'hooks'

export const Loading = ({ children, isLoading, color }) => {
  const colors = useColors()

  return isLoading ? (
    <Grid color={colors(color || 'gray1')} height={60} width={60} />
  ) : (
    children
  )
}

export default Loading
